import React from 'react'
import ReactModal from 'react-modal'
import { Link } from 'react-router-dom'

function CompleteAssistantProfile({uploadNew, onClose}) {
  return (
    <ReactModal
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30
          
        },
        content: {
            height: 'auto',
            width: 'auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >    
        <div className='flex items-center justify-center flex-col my-8'>
        <div className='flex w-full text-md font-bold flex-col justify-center items-center '>
                  <div>
                  Create your Profile and start representing today ! &nbsp;

                  </div>
                  <Link className=' mt-4 text-sm font-bold bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500  rounded p-1 border-purple-700 border text-white ring ring-purple-400 w-max cursor-pointer' to="/profile/0   ">Complete assistant profile now</Link>

                </div>  
         </div>
    </ReactModal>
  )
}

export default CompleteAssistantProfile;